// extracted by mini-css-extract-plugin
export var dropdownButton = "_3p-0";
export var fullWidthDropdownButton = "_3p-1";
export var icon = "_3p-3";
export var iconPlaceholder = "_3p-2";
export var menuItemRow = "_3p-5";
export var shortcutContainer = "_3p-4";